module.exports = __webpack_public_path__ + "img/illustration_L.18f6447e.svg";